import React from "react"
import cx from "classnames"
import EventSection from "./event-section"
import Slims from "../images/eof-slims-poster.jpeg"

const upcomingShows = [
  {
    venue: "Slim's Last Chance",
    address: "5606 1st Ave S",
    city: "Seattle, WA",
    date: "October 22nd, 2026",
    time: "7pm-10pm",
  },
]

const clubs = [
  "Aurora Borealis, Shoreline",
  "O'Malley's Irish Pub, Tacoma",
  "The Skylark Cafe, West Seattle",
  "Purdy's, Sumner",
  "Tim's Tavern, Seattle",
  "The Royal Bear, Algona",
  "56th St Liquor Saloon, Tacoma",
  "The Hidden Door, Shoreline",
  "St. Andrews Pub, Seattle",
  "Lucky Dime, Everett",
  "SandBAR & Grill, Tacoma",
  "Salmon Bake, Browns Point",
]

const Events = () => (
  <div className="events-wrapper">
    <div className="float-child">
      <img className="poster" src={Slims} alt="Gig Poster" />
    </div>
    <div className="float-child event-details">
      <EventSection title="Next Shows" events={upcomingShows} />
      <div className="major played">Clubs We've Played</div>
      <div className="clubs">
        {clubs.map((club, index) => {
          return (
            <div className={cx("club", { even: index % 2 === 0 })}>{club}</div>
          )
        })}
      </div>
    </div>
  </div>
)

export default Events
